// About Us Modal functionality
document.addEventListener('DOMContentLoaded', function() {
  const aboutModal = document.getElementById('about-modal');
  const closeAbout = document.getElementById('close-about');
  const aboutOverlay = document.querySelector('.about-overlay');

  // Close modal function
  function closeAboutModal() {
    aboutModal.classList.remove('active');
    // Close all accordion sections when modal closes
    const sections = document.querySelectorAll('.about-section-btn');
    sections.forEach(section => {
      section.classList.remove('active');
      const content = section.nextElementSibling;
      if (content) {
        content.classList.remove('active');
      }
    });
  }

  // Close modal events
  if (closeAbout) {
    closeAbout.addEventListener('click', closeAboutModal);
  }
  
  if (aboutOverlay) {
    aboutOverlay.addEventListener('click', closeAboutModal);
  }

  // Close on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && aboutModal.classList.contains('active')) {
      closeAboutModal();
    }
  });

  // Accordion functionality
  const sectionButtons = document.querySelectorAll('.about-section-btn');
  sectionButtons.forEach(button => {
    button.addEventListener('click', function() {
      const isActive = this.classList.contains('active');
      
      // Close all other sections
      sectionButtons.forEach(btn => {
        btn.classList.remove('active');
        const content = btn.nextElementSibling;
        if (content) {
          content.classList.remove('active');
        }
      });
      
      // Toggle current section
      if (!isActive) {
        this.classList.add('active');
        const content = this.nextElementSibling;
        if (content) {
          content.classList.add('active');
        }
      }
    });
  });

  // Open modal function (to be called from buttons)
  window.openAboutModal = function() {
    aboutModal.classList.add('active');
    // Open first section by default
    const firstSection = document.querySelector('.about-section-btn');
    if (firstSection) {
      firstSection.classList.add('active');
      const firstContent = firstSection.nextElementSibling;
      if (firstContent) {
        firstContent.classList.add('active');
      }
    }
  };

  console.log('About Us modal with accordion initialized successfully');
});
